import { render } from "./ModalLogout.vue?vue&type=template&id=34befe32&scoped=true"
import script from "./ModalLogout.vue?vue&type=script&lang=js"
export * from "./ModalLogout.vue?vue&type=script&lang=js"

import "./ModalLogout.vue?vue&type=style&index=0&id=34befe32&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34befe32"]])

export default __exports__